var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-sidebar',{attrs:{"lazy":"","width":_vm.widthSidebar,"visible":_vm.vinInformationSideBar.isShowing,"id":"sidebar-vehicle-details","shadow":"","right":""},on:{"hidden":_vm.hideSidebar}},[_c('b-overlay',[_c('VinData')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }